import { createBusEvent } from '../core'

const eventName = 'showcaseCommentSuccess'
const showcaseCommentSuccess = createBusEvent<string>(eventName)

export default showcaseCommentSuccess
